var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TagsInput',{attrs:{"value":_vm.val,"editable":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }